import { Check, Search, User } from "lucide-react";
import { useEffect, useState } from "react";

import { comandasApi } from "./api";

export const CAMPO = "w-full h-10 rounded-lg border bg-background px-3 text-sm outline-none focus:ring-2 focus:ring-primary/30";

/**
 * Cliente da comanda (digita ou escolhe do cadastro, como em Mesas). Usado na
 * Nova comanda e no Editar. `valor` = { nome, clienteId, telefone }.
 */
export default function CampoCliente({ open, valor, onChange, desabilitado = false }) {
  const { nome, clienteId } = valor;
  const [sugestoes, setSugestoes] = useState([]);

  // Busca o cadastro enquanto digita (nome, telefone, CPF), com pausa de 250 ms
  useEffect(() => {
    const termo = (nome || "").trim();
    if (!open || clienteId || termo.length < 2) { setSugestoes([]); return undefined; }
    let vivo = true;
    const t = setTimeout(() => {
      comandasApi.buscarClientes(termo).then((l) => vivo && setSugestoes(Array.isArray(l) ? l : [])).catch(() => vivo && setSugestoes([]));
    }, 250);
    return () => { vivo = false; clearTimeout(t); };
  }, [open, nome, clienteId]);

  return (
    <div className="relative">
      <label className="block text-xs font-medium mb-1">Cliente</label>
      <div className="relative">
        <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input value={nome} data-e2e="comanda-cliente" disabled={desabilitado}
          onChange={(e) => onChange({ nome: e.target.value, clienteId: null, telefone: null })}
          placeholder="Nome, telefone ou CPF (opcional)" className={`${CAMPO} pl-9 ${clienteId ? "pr-9" : ""} disabled:opacity-60`} />
        {clienteId && <Check className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-emerald-500" />}
      </div>
      {sugestoes.length > 0 && (
        <div className="absolute z-20 left-0 right-0 mt-1 rounded-lg border bg-popover shadow-lg max-h-56 overflow-y-auto">
          {sugestoes.map((c) => (
            <button key={c.id} type="button" onMouseDown={() => { onChange({ nome: c.nome || "", clienteId: c.id, telefone: c.telefone || null }); setSugestoes([]); }}
              className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-muted">
              <Search className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
              <span className="min-w-0"><span className="block font-medium truncate">{c.nome}</span>{c.telefone && <span className="block text-xs text-muted-foreground">{c.telefone}</span>}</span>
            </button>
          ))}
        </div>
      )}
      {!desabilitado && (
        <p className="text-[11px] text-muted-foreground mt-1">{clienteId ? "Cliente do cadastro: cashback e cartão fidelidade valem." : "Escolha um cliente do cadastro para cashback e cartão fidelidade."}</p>
      )}
    </div>
  );
}
